import React, { useEffect, useState } from 'react'
import './BlogPage.css'
import axios from 'axios'
import { Link, useParams } from 'react-router-dom'
import { MdOutlineKeyboardBackspace } from "react-icons/md";


const BlogPage = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    const { id } = useParams();

    const [blog, setBlog] = useState()


    useEffect(() => {

        window.scrollTo(0, 0)

        const getBlog = async () => {
            try {
                const data = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/jobs/getblogdata/${id}`);
                setBlog(data.data);
            }
            catch (err) { console.log(err); }
        }

        getBlog()

    }, [id]);


    return (
        <div className='bigscreen !max-w-[1000px] p-16 flex flex-col gap-10'>

            <div className='flex justify-between items-center gap-10'>
                <div className=''>Posted <strong>
                    {blog?.createdAt && new Date(blog.createdAt).toLocaleDateString()}
                </strong>
                </div>

                <Link to={'/blogs'}>
                    <div className='flex gap-2 items-center font-bold text-[var(--primary)]'>
                        <MdOutlineKeyboardBackspace className='text-2xl' />
                        <div>Go to All blogs</div>
                    </div>
                </Link>
            </div>

            <div className='font-semibold text-3xl'>{blog?.title}</div>

            <div className='h-[500px] w-full mx-auto'>
                <img src={blog?.image} className='max-h-full max-w-full object-contain rounded-[20px] shadow-md' />
            </div>

            <div className='mx-1'>
                {blog?.paragraphs &&
                    blog?.paragraphs?.map((paragraph, index) => (
                        <p key={index} className='mb-4 text-justify'>
                            {paragraph}
                        </p>
                    ))}
            </div>

        </div>
    )
}

export default BlogPage